import { gql } from '@apollo/client';

export const SOLANA_INSTRUCTION = gql`
  fragment SolanaInstruction on IdentifierBasedInstruction {
    id
    identifier
    treatmentId
    treatment {
      id
      name
      description
      reconOrder
    }
    notes
    publicName
    publicNotes
    updatedAt
    tokenParam1
    tokenParam2
  }
`;
